import React from 'react';
import { NAME, RESORT_EMAIL, RESORT_PHONE_1, RESORT_PHONE_2, RESORT_WEBSITE } from '../../Helper/user';

function FooterInvoice() {
  const contactInfo = [
    // {
    //   label: `${RESORT_NAME_AR} - ${RESORT_NAME_EN}`,
    //   icon: 'fa-flag',
    // },
    {
      label: `${RESORT_PHONE_1}${RESORT_PHONE_2 ? ` - ${RESORT_PHONE_2}` : ''}`,
      icon: 'fa-phone',
    },
    {
      label: RESORT_WEBSITE || 'yoursummer.ly',
      icon: 'fa-globe',
    },
    {
      label: RESORT_EMAIL || 'info@yoursummer.ly',
      icon: 'fa-envelope',
    },
    {
      label: NAME,
      icon: 'fa-user',
    },
  ];

  return (
    <div className='last-child'>
      <div class="footer">
        <div class="table-responsive">
          <table className="table" >
            <thead >
              {/* <tr>
            <th className="font-bold font-13 text-center" colSpan={10}>
              <center>
                نتمنى لكم قضاء صيف رائع في {RESORT_NAME_AR} - {RESORT_NAME_EN}
              </center>
            </th>
          </tr> */}

              <tr >
                {contactInfo.map((item, index) => (
                  item.label != null && item.label != "null" &&
                  <th key={index} style={{ borderTop: "1px solid #ddd" }}>
                    <div className="font-13" >
                      <b>{item.label}</b> <i className={`fa ${item.icon}`} aria-hidden="true"></i>
                    </div>
                  </th>

                ))}
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>
  );
}

export default FooterInvoice;
